import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import "./admin/admin.css";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import ServicesIndex from "./pages/ServicesIndex";
import AreasIndex from "./pages/AreasIndex";
import AreaDetail from "./pages/AreaDetail";
import TopicPage from "./pages/TopicPage";
import ZorbaProfile from "./pages/ZorbaProfile";
import ZorbaSubpage from "./pages/ZorbaSubpage";
import Guides from "./pages/Guides";
import GuideDetail from "./pages/GuideDetail";
import GiftVouchers from "./pages/GiftVouchers";
import VoucherSuccess from "./pages/VoucherSuccess";
import ShareExperience from "./pages/ShareExperience";
import Legal from "./pages/Legal";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import { AdminAuthProvider } from "./admin/AdminAuth";
import { AuthCallbackHandler } from "./admin/AuthCallback";
import AdminLayout from "./admin/AdminLayout";
import AdminHome from "./admin/AdminHome";
import AdminSeo from "./admin/AdminSeo";
import AdminOffers from "./admin/AdminOffers";
import AdminVouchers from "./admin/AdminVouchers";
import AdminReviews from "./admin/AdminReviews";
import AdminLogin from "./admin/AdminLogin";
import { StaffAuthProvider } from "./staff/StaffAuth";
import StaffLogin from "./staff/StaffLogin";
import StaffPortal from "./staff/StaffPortal";

export default function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <StaffAuthProvider>
          <Routes>
            {/* Admin ------------------------------------------------------ */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/auth/callback" element={<AuthCallbackHandler />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminHome />} />
              <Route path="seo" element={<AdminSeo />} />
              <Route path="offers" element={<AdminOffers />} />
              <Route path="vouchers" element={<AdminVouchers />} />
              <Route path="reviews" element={<AdminReviews />} />
            </Route>
            {/* Staff ------------------------------------------------------ */}
            <Route path="/staff/login" element={<StaffLogin />} />
            <Route path="/staff" element={<StaffPortal />} />
            {/* Public ----------------------------------------------------- */}
            <Route
              path="/*"
              element={
                <Layout>
                  {(onBook) => (
                    <Routes>
                      <Route path="/" element={<Home onBook={onBook} />} />
                      <Route path="/spa-services-bhubaneswar/" element={<ServicesIndex onBook={onBook} />} />
                      <Route path="/services/:slug/" element={<ServiceDetail onBook={onBook} />} />
                      <Route path="/areas/" element={<AreasIndex onBook={onBook} />} />
                      <Route path="/areas/:slug/" element={<AreaDetail onBook={onBook} />} />
                      {/* Legacy area slug redirect */}
                      <Route path="/areas/airport-area/" element={<Navigate to="/areas/bhubaneswar-airport/" replace />} />
                      {/* Legacy service slug redirects (old *-therapy -> new *-massage) */}
                      <Route path="/services/swedish-therapy/" element={<Navigate to="/services/swedish-massage/" replace />} />
                      <Route path="/services/balinese-therapy/" element={<Navigate to="/services/balinese-massage/" replace />} />
                      <Route path="/services/aroma-therapy/" element={<Navigate to="/services/aroma-massage/" replace />} />
                      <Route path="/services/jacuzzi-therapy/" element={<Navigate to="/services/jacuzzi-spa/" replace />} />
                      <Route path="/zorba-international-spa/" element={<ZorbaProfile onBook={onBook} />} />
                      <Route path="/zorba-services/" element={<ZorbaSubpage page="services" onBook={onBook} />} />
                      <Route path="/zorba-packages/" element={<ZorbaSubpage page="packages" onBook={onBook} />} />
                      <Route path="/zorba-location/" element={<ZorbaSubpage page="location" onBook={onBook} />} />
                      <Route path="/zorba-contact/" element={<ZorbaSubpage page="contact" onBook={onBook} />} />
                      <Route path="/guides/" element={<Guides />} />
                      <Route path="/guides/:slug/" element={<GuideDetail onBook={onBook} />} />
                      <Route path="/gift-vouchers/" element={<GiftVouchers />} />
                      <Route path="/gift-vouchers/success/" element={<VoucherSuccess />} />
                      <Route path="/share-your-experience/" element={<ShareExperience />} />
                      <Route path="/contact/" element={<Contact onBook={onBook} />} />
                      <Route path="/privacy-policy/" element={<Legal page="privacy-policy" />} />
                      <Route path="/terms/" element={<Legal page="terms" />} />
                      <Route path="/cancellation-policy/" element={<Legal page="cancellation-policy" />} />
                      <Route path="/booking-policy/" element={<Legal page="booking-policy" />} />
                      <Route path="/disclaimer/" element={<Legal page="disclaimer" />} />
                      <Route path="/:slug/" element={<TopicPage onBook={onBook} />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  )}
                </Layout>
              }
            />
          </Routes>
        </StaffAuthProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}
